<app-html-news [news]="news"></app-html-news>
<div class="players-table-description">
  <span translate translation="listOfRegisteredPlayers"></span>
  <span>:</span>
</div>
<div class="players-table" data-test-id="online-cup-players-table">
  <div *ngFor="let row of range(rowCount)" class="players-row">
    <div *ngFor="let column of range(columnCount)" class="players-cell">
      <div class="number">{{ column * rowCount + row + 1 }}</div>
      <div class="player">
        <ng-container *ngIf="registeredPlayers[column * rowCount + row] as player">
          <app-player-cell
            [country]="player.country"
            [nick]="player.nick"
            [playerId]="player.id"
            class="player-cell"
          ></app-player-cell>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="buttons-container">
  <button
    *ngIf="showStreamersTimerLink$ | async"
    (click)="goToStreamersTimer()"
    mat-raised-button
    color="primary"
    class="action-button"
    data-test-id="streamers-timer-button"
  >
    <span translate translation="openStreamersTimer"></span>
  </button>
  <button
    (click)="toggleRegistration()"
    mat-raised-button
    color="primary"
    class="action-button"
    data-test-id="button-toggle-cup-registration"
  >
    <span *ngIf="isRegistered" translate translation="cancelRegistration"></span>
    <span *ngIf="!isRegistered" translate translation="registerForCup"></span>
  </button>
  <button (click)="openFullTable()" mat-raised-button color="primary" class="action-button">
    <span translate translation="fullTable"></span>
  </button>
</div>
